import React, { Component } from 'react';

import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Switch from '@material-ui/core/Switch';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import CloseIcon from '@material-ui/icons/Close';
import DownloadIcon from '@material-ui/icons/VerticalAlignBottom';
import IconButton from '@material-ui/core/IconButton';

import Styled from './styles';
import { validateDomain, validateCompanyId } from '../../utils/validate';

import api from '../../lib/api';

import PlaceholderImage from '../../images/pojo-placeholder-2.png';

class PayCompany extends Component {
  constructor(props) {
    super(props);

    this.INITIAL_STATE = {
      companyId: '',
      invoiceId: '',
      paymentReceiptId: '',
      paymentPlan: null,
      paymentMode: '',
      isTrial: false,
      startTime: '',
      expiryTime: '',
      inAppProductId: null,
      submitting: false,
      submitSuccess: false,
      submitFail: false,
      disableFields: true,
      domain: '',
      disableDomainField: true,
      domainExtension: '',
      domainError: false,
      companyIdError: false,
      logoSelected: null,
      companyLogoExist: false,
      amountError: false,
      amount: 0,
      showSubmitButton: false,
      showRefundButton: false,
      showRevokeButton: false,
      invoiceIdError: false,
      receiptIdError: false
    };

    this.state = { ...this.INITIAL_STATE };
  }

  // paymentPlans = [
  //   { value: 'GOLD', label: 'Gold' },
  //   { value: 'PLATINUM', label: 'Platinum' }
  // ];
  paymentPlans = [
    { value: 'LITE', label: 'Lite' },
    { value: 'PREMIUM', label: 'Premium' },
    { value: 'GROWTH', label: 'Growth' },
    { value: 'PLATINUM', label: 'Platinum' },
    { value: 'UNLIMITED', label: 'Unlimited' }
  ];

  paymentModes = [
    { value: 'CASH', label: 'Cash' },
    { value: 'PAYTM', label: 'Paytm' },
    { value: 'PAYMENT_LINK', label: 'Payment Link' },
    { value: 'CHEQUE', label: 'Cheque' },
    { value: 'OTHER', label: 'Other' },
    { value: 'REDEEM', label: 'Referral redeem' }
  ];

  durationPresets = [
    { value: 'MANUAL_7_DAYS', label: '7 days' },
    { value: 'MANUAL_1_MONTH', label: '1 month' },
    { value: 'MANUAL_3_MONTHS', label: '3 months' },
    { value: 'MANUAL_6_MONTHS', label: '6 months' },
    { value: 'MANUAL_9_MONTHS', label: '9 months' },
    { value: 'MANUAL_1_YEAR', label: '1 year' },
    { value: 'qs_siyaram_15_months', label: '15 months siyaram' }
  ];

  onCompanyIdChange = event => {
    this.setState({ companyId: event.target.value });
  };

  onInvoiceIdChange = event => {
    this.setState({ invoiceId: event.target.value });
  };

  onPaymentReceiptIdChange = event => {
    this.setState({ paymentReceiptId: event.target.value });
  };

  onPaymentPlanChange = event => {
    this.setState({ paymentPlan: event.target.value });
  };

  onTrialChange = () => {
    this.setState({ isTrial: !this.state.isTrial });
  };

  onPaymentModeChange = event => {
    this.setState({ paymentMode: event.target.value });
  };

  onDomainNameChange = event => {
    this.setState({ domain: event.target.value });
  };

  onAmountChange = event => {
    this.setState({ amount: event.target.value });
  };

  onDownload = async () => {
    const { companyId } = this.state;

    try {
      if (companyId && validateCompanyId(companyId)) {
        const { paymentState, domainName } = await api.getCompanyMetaData({
          companyId
        });

        let domainUpdates = {};
        if (domainName) {
          if (domainName.includes('.catalog.to')) {
            domainUpdates = {
              disableDomainField: false,
              domainExtension: '.catalog.to',
              domain: domainName.split('.')[0]
            };
          } else {
            const domainExtension = `.${domainName
              .split('.')
              .slice(1)
              .join('.')}`;

            domainUpdates = {
              disableDomainField: true,
              domainExtension: domainExtension,
              domain: domainName.split('.')[0]
            };
          }
        } else {
          domainUpdates = {
            disableDomainField: false,
            domainExtension: '.catalog.to'
          };
        }

        this.logoSelector.value = null;

        this.setState({
          lastTransactionId: paymentState.transactionId,
          invoiceId: paymentState.invoiceId || '',
          paymentReceiptId: paymentState.paymentReceiptId || '',
          paymentPlan:
            paymentState.planType || paymentState.paymentPlan || null,
          paymentMode: paymentState.paymentMode || '',
          inAppProductId: paymentState.inAppProductId || null,
          isTrial: !!paymentState.isTrial,
          startTime: paymentState.startTime || '',
          expiryTime: paymentState.expiryTime || '',
          disableFields: false,
          showSubmitButton:
            !!paymentState.isTrial ||
            moment(paymentState.expiryTime || 0)
              .toDate()
              .getTime() < Date.now() ||
            paymentState.planType === 'FREE',
          showRefundButton:
            !paymentState.isTrial &&
            moment(paymentState.expiryTime || 0)
              .toDate()
              .getTime() > Date.now() &&
            paymentState.planType !== 'FREE',
          showRevokeButton:
            !paymentState.isTrial &&
            moment(paymentState.startTime || 0)
              .add(2, 'days')
              .toDate()
              .getTime() > Date.now() &&
            moment(paymentState.expiryTime || 0)
              .toDate()
              .getTime() > Date.now() &&
            paymentState.planType !== 'FREE',
          ...domainUpdates
        });
      } else {
        console.log(
          'Bad company id: either empty or contains special characters not supported by firebase'
        );
        this.setState({ companyIdError: true });
      }
    } catch (ex) {
      console.log('ERROR', ex);
      this.setState({ companyIdError: true });
    }
  };

  onSubmit = async () => {
    const {
      companyId,
      invoiceId,
      paymentReceiptId,
      paymentPlan,
      isTrial,
      paymentMode,
      startTime,
      expiryTime,
      inAppProductId,
      domain,
      domainExtension
    } = this.state;

    let { amount } = this.state;

    this.setState({ submitting: true });

    try {
      if (!isTrial && !invoiceId) {
        this.setState({
          invoiceIdError: true,
          submitting: false,
          submitSuccess: false
        });
        return;
      }
      if (!paymentReceiptId) {
        this.setState({
          receiptIdError: true,
          submitting: false,
          submitSuccess: false
        });
        return;
      }
      if (!isTrial && Number(amount) === 0) {
        this.setState({
          amountError: true,
          submitting: false,
          submitSuccess: false
        });
        return;
      }
      amount /= 70;
      this.setState(this.INITIAL_STATE);
      if (validateDomain(domain)) {
        const formattedDomain = domain ? `${domain}${domainExtension}` : '';

        await Promise.all([
          api.addCompanyPayData({
            companyId,
            invoiceId,
            paymentReceiptId,
            paymentPlan,
            isTrial,
            paymentMode,
            domain: formattedDomain,
            startTime: moment(startTime, 'YYYY-MM-DD')
              .toDate()
              .toISOString(),
            expiryTime,
            inAppProductId,
            amount
          }),
          this.onLogoUpload()
        ]);

        this.setState(this.INITIAL_STATE);
      } else {
        this.setState({ domainError: true });
      }
    } catch (ex) {
      console.log('ERROR', ex);

      this.setState({
        submitting: false,
        submitSuccess: false,
        submitFail: `${ex.response.data.status || 500}: ${ex.response.data
          .message || 'Server Error'}`
      });
    }
  };

  onExpire = async expiryType => {
    const { companyId, startTime, lastTransactionId } = this.state;

    this.setState({ submitting: true });

    try {
      await api.expireCompany({ companyId, expiryType, lastTransactionId });

      this.setState(this.INITIAL_STATE);
    } catch (ex) {
      console.log('ERROR', ex);

      this.setState({
        submitting: false,
        submitSuccess: false,
        submitFail: `${ex.response.data.status || 500}: ${ex.response.data
          .message || 'Server Error'}`
      });
    }
  };

  onLogoSelected = event => {
    this.setState({ logoSelected: event.target.files[0] });
  };

  onLogoUpload = async () => {
    const { logoSelected, companyId } = this.state;
    try {
      if (logoSelected) {
        await api.uploadCompanyLogo({
          logoSelected,
          companyId
        });

        this.setState({ logoSelected: null });
      }
    } catch (ex) {
      console.log('ex', ex.response.data);
    }
  };

  onStartDatePicked = event => {
    const datePicked = event.target.value;

    this.setState({
      inAppProductId: null,
      startTime:
        datePicked && datePicked.length
          ? new Date(datePicked).toISOString()
          : ''
    });
  };

  onExpiryDatePicked = event => {
    const datePicked = event.target.value;

    this.setState({
      expiryTime:
        datePicked && datePicked.length
          ? new Date(datePicked).toISOString()
          : ''
    });
  };

  onPresetSelect = preset => {
    const { startTime } = this.state;

    if (!startTime) {
      this.setState({
        submitFail: 'No start time'
      });

      return;
    }

    let addParams = [];
    let isTrial = this.state.isTrial;
    switch (preset.value) {
      case 'MANUAL_7_DAYS': {
        addParams = [7, 'days'];
        break;
      }
      case 'MANUAL_1_MONTH': {
        isTrial = false;
        addParams = [1, 'month'];
        break;
      }
      case 'MANUAL_3_MONTHS': {
        isTrial = false;
        addParams = [3, 'months'];
        break;
      }
      case 'MANUAL_6_MONTHS': {
        isTrial = false;
        addParams = [6, 'months'];
        break;
      }
      case 'MANUAL_9_MONTHS': {
        isTrial = false;
        addParams = [9, 'months'];
        break;
      }
      case 'MANUAL_1_YEAR': {
        isTrial = false;
        addParams = [1, 'year'];
        break;
      }
      case 'qs_siyaram_15_months': {
        isTrial = false;
        addParams = [15, 'months'];
        break;
      }
      default: {
        //
      }
    }

    const expiryTime = moment(startTime)
      .add(...addParams)
      .toDate()
      .toISOString();

    this.setState({ expiryTime, inAppProductId: preset.value, isTrial });
  };

  formatDateForInput = date => {
    if (!date) {
      return '';
    }

    return moment(date).format('YYYY-MM-DD');
  };

  logoNotAvailable = () => {
    this.setState({ companyLogoExist: false });
  };

  renderCompanyLogo = companyLogoExist => {
    const path =
      'https://s3.ap-south-1.amazonaws.com/quicksell-logos/' +
      this.state.companyId +
      '.jpg?a=' +
      Date.now();

    if (companyLogoExist && this.state.companyId) {
      return <img src={path} alt="" onError={this.logoNotAvailable} />;
    } else {
      return <img src={PlaceholderImage} alt="" />;
    }
  };

  onSnackbarClose = () => {
    this.setState({
      submitting: false,
      submitSuccess: false,
      submitFail: false
    });
  };

  renderSnackbarMessage = () => {
    const { submitSuccess, submitFail } = this.state;

    let message = '';
    if (submitFail) {
      message = submitFail;
    } else if (submitSuccess) {
      message = 'Success!';
    }

    return (
      <Styled.SnackbarMessage error={!!submitFail}>
        {message}
      </Styled.SnackbarMessage>
    );
  };

  render() {
    const {
      companyId,
      invoiceId,
      paymentReceiptId,
      paymentPlan,
      paymentMode,
      isTrial,
      submitting,
      submitSuccess,
      submitFail,
      domain,
      disableFields,
      disableDomainField,
      domainExtension,
      domainError,
      companyIdError,
      logoSelected,
      companyLogoExist,
      startTime,
      expiryTime,
      inAppProductId,
      amountError,
      amount,
      showSubmitButton,
      showRefundButton,
      showRevokeButton,
      invoiceIdError,
      receiptIdError
    } = this.state;

    const formattedStartTime = this.formatDateForInput(startTime);
    const formattedExpiryTime = this.formatDateForInput(expiryTime);

    return (
      <Styled.Container>
        <Styled.Header>
          <Styled.CompanyInputContainer>
            <TextField
              error={companyIdError}
              required
              fullWidth
              label="Company ID"
              margin="normal"
              type="text"
              value={companyId}
              onChange={this.onCompanyIdChange}
            />
          </Styled.CompanyInputContainer>

          <Styled.DownloadButtonContainer>
            <Button
              variant="flat"
              size="small"
              color="primary"
              onClick={this.onDownload}
            >
              Get existing data
              <DownloadIcon nativeColor="black" />
            </Button>
          </Styled.DownloadButtonContainer>
        </Styled.Header>

        <Styled.Row>
          <Styled.Left>
            <Styled.Row>
              <Styled.Left>
                <Styled.InvoiceInputContainer>
                  <TextField
                    error={invoiceIdError}
                    required
                    fullWidth
                    label="Invoice ID"
                    margin="normal"
                    type="text"
                    value={invoiceId}
                    onChange={this.onInvoiceIdChange}
                    disabled={disableFields}
                  />
                </Styled.InvoiceInputContainer>
              </Styled.Left>
              <Styled.Right>
                <Styled.PaymentReceiptInputContainer>
                  <TextField
                    error={receiptIdError}
                    required
                    fullWidth
                    label="Receipt ID"
                    margin="normal"
                    type="text"
                    value={paymentReceiptId}
                    onChange={this.onPaymentReceiptIdChange}
                    disabled={disableFields}
                  />
                </Styled.PaymentReceiptInputContainer>
              </Styled.Right>
            </Styled.Row>
          </Styled.Left>

          <Styled.Right>
            <Styled.LogoUploadButtonContainer>
              <input
                type="file"
                accept="image/jpeg, image/jpg"
                onChange={this.onLogoSelected}
                ref={el => (this.logoSelector = el)}
              />
              <Button
                variant="contained"
                color="default"
                onClick={this.onLogoUpload}
                disabled={logoSelected && companyId ? false : true}
              >
                Upload
              </Button>
              <Styled.LogoContainer>
                {this.renderCompanyLogo(companyLogoExist)}
              </Styled.LogoContainer>
            </Styled.LogoUploadButtonContainer>
          </Styled.Right>
        </Styled.Row>

        <Styled.Row>
          <Styled.Left>
            <Styled.Row>
              <Styled.Left>
                <Styled.DomainNameContainer>
                  <TextField
                    error={domainError}
                    fullWidth
                    label="domain name"
                    margin="normal"
                    type="text"
                    value={domain}
                    onChange={this.onDomainNameChange}
                    disabled={disableFields || disableDomainField}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {domainExtension}
                        </InputAdornment>
                      )
                    }}
                  />
                </Styled.DomainNameContainer>
              </Styled.Left>
              <Styled.Right>
                <Styled.PaymentModeContainer>
                  <FormControl style={{ minWidth: 150 }}>
                    <InputLabel htmlFor="payment-mode">Payment Mode</InputLabel>
                    <Select
                      value={paymentMode}
                      onChange={this.onPaymentModeChange}
                      inputProps={{
                        name: 'paymentMode',
                        id: 'payment-mode'
                      }}
                      disabled={disableFields}
                    >
                      {this.paymentModes.map(mode => (
                        <MenuItem key={mode.value} value={mode.value}>
                          {mode.label}
                        </MenuItem>
                      ))}
                    </Select>

                    <TextField
                      error={amountError}
                      fullWidth
                      label="Amount in INR"
                      margin="normal"
                      type="number"
                      value={amount}
                      onChange={this.onAmountChange}
                      disabled={disableFields}
                    />
                  </FormControl>
                </Styled.PaymentModeContainer>
              </Styled.Right>
            </Styled.Row>
          </Styled.Left>
        </Styled.Row>

        <Styled.Row>
          <Styled.Left>
            <Styled.Row>
              <Styled.Left>
                <Styled.PaymentSelectionContainer>
                  <Styled.PaymentPlanContainer>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Payment Plan</FormLabel>
                      <Styled.Spacer />
                      <RadioGroup
                        aria-label="payment-plan"
                        name="paymentPlan"
                        value={paymentPlan}
                        onChange={this.onPaymentPlanChange}
                      >
                        {this.paymentPlans.map(plan => (
                          <FormControlLabel
                            key={plan.value}
                            value={plan.value}
                            control={<Radio />}
                            label={plan.label}
                            disabled={disableFields}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </Styled.PaymentPlanContainer>
                  <Styled.TrialContainer>
                    <FormControl component="fieldset">
                      <FormControlLabel
                        label="Trial"
                        control={
                          <Switch
                            checked={isTrial}
                            onChange={this.onTrialChange}
                            disabled={disableFields}
                          />
                        }
                      />
                    </FormControl>
                  </Styled.TrialContainer>
                </Styled.PaymentSelectionContainer>
              </Styled.Left>
              <Styled.Right>
                <Styled.PlanDuration>
                  <Styled.StartDatePicker>
                    <TextField
                      label="Plan start"
                      type="date"
                      disabled={disableFields}
                      onChange={this.onStartDatePicked}
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={formattedStartTime}
                    />
                  </Styled.StartDatePicker>
                  <Styled.ExpiryDatePicker>
                    <div>Plan expiry</div>
                    <div>{formattedExpiryTime}</div>
                  </Styled.ExpiryDatePicker>
                  <Styled.PresetDurations>
                    {this.durationPresets.map(preset => (
                      <Styled.PresetDuration key={preset.value}>
                        <Button
                          variant="contained"
                          color={
                            inAppProductId === preset.value
                              ? 'primary'
                              : 'default'
                          }
                          onClick={() => this.onPresetSelect(preset)}
                          disabled={disableFields}
                        >
                          {preset.label}
                        </Button>
                      </Styled.PresetDuration>
                    ))}
                  </Styled.PresetDurations>
                </Styled.PlanDuration>
              </Styled.Right>
            </Styled.Row>
          </Styled.Left>
        </Styled.Row>

        <Styled.FinalizeButtonContainer>
          {showRefundButton && (
            <Styled.ExpireButtonContainer>
              <Button
                variant="raised"
                color="secondary"
                disabled={submitting || disableFields}
                onClick={() => this.onExpire('REFUND')}
              >
                Refund
              </Button>
            </Styled.ExpireButtonContainer>
          )}
          {showRevokeButton && (
            <Styled.ExpireButtonContainer>
              <Button
                variant="raised"
                color="secondary"
                disabled={submitting || disableFields}
                onClick={() => this.onExpire('REVOKE')}
              >
                Revoke
              </Button>
            </Styled.ExpireButtonContainer>
          )}
          {showSubmitButton && (
            <Styled.SubmitButtonContainer>
              <Button
                fullWidth
                variant="raised"
                color="primary"
                disabled={submitting || disableFields}
                onClick={this.onSubmit}
              >
                Submit
              </Button>
            </Styled.SubmitButtonContainer>
          )}
        </Styled.FinalizeButtonContainer>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          open={!!submitSuccess || !!submitFail}
          autoHideDuration={6000}
          onClose={this.onSnackbarClose}
          message={this.renderSnackbarMessage()}
          action={[
            <IconButton key={0} onClick={this.onSnackbarClose}>
              <CloseIcon nativeColor="#fff" />
            </IconButton>
          ]}
        />
      </Styled.Container>
    );
  }
}

export default PayCompany;



// WEBPACK FOOTER //
// ./src/pages/PayCompany/index.js